import React, { useEffect, useMemo, useRef, useState } from "react";
import { Button, Spinner, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaEye, FaPaperPlane, FaPen, FaPrint } from "react-icons/fa";
import Disposisi from "../../../../utilities/Disposisi";
import ModalProses from "../../../penugasan/modals/ModalProses";
import ModalSpp from "../../../penugasan/modals/ModalSpp";
import ModalLapEv from "../../../penugasan/modals/ModalLapEv";
import ModalLapVerLap from "../../../penugasan/modals/ModalLapVerLap";
import ModalCetak from "../../../penugasan/modals/ModalCetak";
import ModalPnbp from "../../../penugasan/modals/ModalPnbp";
import { formatDateString, formatDateTimeLocalDate, getCurrentDateTimeFormattedOnly } from "../../../../utilities/Utils";
import TransaksiService from "../../../../services/transaksi/TransaksiService";
import Card from "../../../../components/Card";
import ModalViewProses from "../../../penugasan/modals/ModalViewProses";
import ModalViewSpp from "../../../penugasan/modals/ModalViewSpp";
import SweetAlert from "react-bootstrap-sweetalert";
import ModalViewLapEv from "../../../penugasan/modals/ModalViewLapEv";
import ModalViewLapVerLap from "../../../penugasan/modals/ModalViewLapVerLap";
import PbUmkuService from "../../../../services/pbumku/PbumkuService";
import MasterService from "../../../../services/master/MasterService";
import { QRCodeCanvas } from "qrcode.react";
import { generatePdfToBlob } from "../../../cetak/draft-pdf/GeneratePdfToBlob";
import UploadService from "../../../../services/transaksi/UploadService";


const ExpandableComponent = ({ data, reloadList }) => {

    let transaksiService = useMemo(() => new TransaksiService(), [])
    const [listDisposisi, setListDisposisi] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const getDisposisi = async () => {
            setLoading(true)
            try {
                const _resDispo = await transaksiService.listPenugasanAll(data.nomorAju)
                setListDisposisi(_resDispo.data.data)
            } catch (error) {
                console.log(error)
            }
            setLoading(false)
        }
        getDisposisi()
    }, [transaksiService, data])

    return (
        <>
            <Card>
                <Card.Body>
                    {loading && <Spinner />}
                    <div className="iq-timeline0 m-0 d-flex align-items-center justify-content-between position-relative">
                        <ul className="list-inline p-0 m-0 w-100">
                            {
                                listDisposisi.map((disp, index) => {
                                    return (
                                        <li key={index}>
                                            <div className="timeline-dots timeline-dot1 border-danger text-primary"></div>
                                            <h6 className="float-left mb-1"><Disposisi idDisposisi={disp.idDisposisi} /></h6>
                                            <small>Nomor : {disp.noTugas} / Tanggal : {disp.tglTugas !== null && formatDateTimeLocalDate(disp.createdAt)}</small>
                                            {
                                                (disp.idDisposisi === 9) &&
                                                <div className="d-inline-block w-100">
                                                    <small>Nomor Sertifikat / Nomor Seri Electronic : <strong><GetNomorSertifikat nomoraju={data.nomorAju} noTugas={disp.noTugas} /></strong></small>
                                                </div>
                                            }
                                            <div className="d-inline-block w-100">
                                                <DisposisiProses datappm={data} dataPenugasan={disp} reloadList={reloadList} />
                                            </div>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </Card.Body>
            </Card>
        </>
    )
}

const DisposisiProses = ({ datappm, dataPenugasan, reloadList }) => {
    // console.log(dataPenugasan)
    const [dataDisposisi, setDataDisposisi] = useState({})

    const [showAddProses, setShowAddProses] = useState(false)
    const handleCloseAddProses = () => setShowAddProses(false)
    const [showAddPenugasan, setShowAddPenugasan] = useState(false);
    const handleCloseAddPenugasan = () => setShowAddPenugasan(false);
    const [showAddLapEv, setShowAddLapEv] = useState(false)
    const handleCloseAddLapEv = () => setShowAddLapEv(false)
    const [showAddLapVerLap, setShowAddLapVerLap] = useState(false)
    const handleCloseAddLapVerLap = () => setShowAddLapVerLap(false)
    // const [showAddLapOrg, setShowAddLapOrg] = useState(false)
    // const handleCloseAddLapOrg = () => setShowAddLapOrg(false)
    const [showCetak, setShowCetak] = useState(false)
    const handleCloseCetak = () => setShowCetak(false)
    const [showPnbp, setShowPnbp] = useState(false)
    const handleClosePnbp = () => setShowPnbp(false)

    // const handleShowAdd = (dataPenugasan) => {
    //     setDataDisposisi(dataPenugasan)
    //     if (dataPenugasan.idDisposisi === 1) {
    //         setShowAddProses(true)
    //     } else if (dataPenugasan.idDisposisi === 2 || dataPenugasan.idDisposisi === 4 || dataPenugasan.idDisposisi === 5 || dataPenugasan.idDisposisi === 6) {
    //         setShowAddPenugasan(true)
    //     } else if (dataPenugasan.idDisposisi === 3) {
    //         setShowAddLapEv(true)
    //     } else if (dataPenugasan.idDisposisi === 8) {
    //         setShowAddLapVerLap(true)
    //     } else if (dataPenugasan.idDisposisi === 7) {
    //         setShowAddLapOrg(true)
    //     } else if (dataPenugasan.idDisposisi === 10) {
    //         setShowPnbp(true)
    //     }
    // }

    const handleClickCetak = (dataPenugasan) => {
        // console.log('cetak')
        setDataDisposisi(dataPenugasan)
        setShowCetak(true)
    }

    const [showViewProses, setShowViewProses] = useState(false)
    const handleCloseViewProses = () => setShowViewProses(false)
    const [showViewPenugasan, setShowViewPenugasan] = useState(false)
    const handleCloseViewPenugasan = () => setShowViewPenugasan(false)
    const [showViewLapEv, setShowViewLapEv] = useState(false)
    const handleCloseViewLapEv = () => setShowViewLapEv(false)
    const [showViewLapVerLap, setShowViewLapVerLap] = useState(false)
    const handleCloseViewLapVerLap = () => setShowViewLapVerLap(false)

    const handleShowView = (dataPenugasan) => {
        setDataDisposisi(dataPenugasan)
        if (dataPenugasan.idDisposisi === 1) {
            setShowViewProses(true)
        } else if (dataPenugasan.idDisposisi === 2 || dataPenugasan.idDisposisi === 5 || dataPenugasan.idDisposisi === 4) {
            setShowViewPenugasan(true)
        } else if (dataPenugasan.idDisposisi === 3) {
            setShowViewLapEv(true)
        } else if (dataPenugasan.idDisposisi === 8) {
            setShowViewLapVerLap(true)
        }
    }

    let transaksiService = useMemo(() => new TransaksiService(), [])
    let pbumkuService = useMemo(() => new PbUmkuService(), [])
    let masterService = useMemo(() => new MasterService(), [])
    let uploadService = useMemo(() => new UploadService(), [])

    const currentDate = new Date()
    // const currentMonth = currentDate.getMonth() + 1
    const currentYear = currentDate.getFullYear()
    const [fileName, setFileName] = useState(null)
    const [urlFile, setUrlFile] = useState(null)

    const [dataPpm, setDataPpm] = useState(null)
    const [showConfirmUpdCetakan, setShowConfirmUpdCetakan] = useState(false)
    const handleCloseConfirmUpdCetakan = () => setShowConfirmUpdCetakan(false)
    const [showUpdCetakanSuccess, setShowUpdCetakanSuccess] = useState(false)
    const [showUpdCetakanFailed, setShowUpdCetakanFailed] = useState(false)
    const [loadingUpdate, setLoadingUpdate] = useState(false)
    const [loadingSetuju, setLoadingSetuju] = useState(false)

    const handleClickUpdCetakan = (dataPpm, dataPenugasan) => {
        setDataPpm(dataPpm)
        setDataDisposisi(dataPenugasan)
        setShowConfirmUpdCetakan(true)
    }

    const handleClickSaveUpdCetakan = async () => {
        try {
            setLoadingUpdate(true)
            const dataMutu = await transaksiService.getPpmMutuById(dataPpm.nomorAju)
            let jsonHcMutu = {
                nomorAju: dataPpm.nomorAju,
                noProses: dataDisposisi.noTugas
            }
            const resDataHc = await transaksiService.getHcMutuById(jsonHcMutu)

            let dataHcMutuUpd = {
                ...resDataHc.data,
                nmPengirim: dataPpm.namaTrader,
                alPengirim: dataPpm.alamatTrader,
                kdposPengirim: dataPpm.kodeposTrader,
                telpPengirim: '-',
                nmPenerima: dataPpm.namaPartner,
                alPenerima: dataPpm.alamatPartner,
                kdposPenerima: '-',
                telpPenerima: '-',
                noRegUpi: dataMutu.data.upiRegNo,
                nmUpi: dataMutu.data.upiNama,
                alUpi: dataMutu.data.upiAlamat,
                telpUpi: dataMutu.data.upiTelp,
                deskripsiProduk: dataMutu.data.mutuDesk,
                spesiesProduk: dataMutu.data.mutuJnsProduk,
                negaraAsalProduk: dataMutu.data.mutuNegAsalProduk !== undefined ? dataMutu.data.mutuNegAsalProduk : '-',
                wilayahAsalProduk: dataMutu.data.mutuNegAsalProduk !== undefined ? dataMutu.data.mutuNegAsalProduk : '-',
                culturedArea: dataMutu.data.mutuArea,
                catchArea: dataMutu.data.mutuTangkapArea,
                kapalTangkap: dataMutu.data.mutuNamaKapal,
                processingType: dataMutu.data.mutuProses,
                temperatureUraian: dataMutu.data.mutuTemp,
                ktgrTemperature: dataMutu.data.mutuTempTipe,
                konsumsi: dataPpm.peruntukan,
                netto: dataPpm.netto !== null ? dataPpm.netto : 0,
                bruto: dataPpm.bruto !== null ? dataPpm.bruto : 0,
                nmJnsTrans: dataPpm.angkut !== null ? dataPpm.angkut : '-',
                jnsTrans: dataPpm.moda !== null ? dataPpm.moda : '-',
                nmTrans: dataPpm.angkut !== null ? dataPpm.angkut : '-',
                noFlight: dataPpm.voyage !== null ? dataPpm.voyage : '-',
                nmTransLain: dataPpm.angkut !== null ? dataPpm.angkut : '-',
                tglBerangkat: formatDateString(dataPpm.tanggalTibaBerangkat),
                nmNgrTujuan: dataPpm.negaraPartner,
                kdNgrTujuan: dataPpm.negaraPartner,
                pelAsal: dataPpm.pelabuhanMuat,
                pelTujuan: dataPpm.pelabuhanBongkar,
                addInfo: dataMutu.data.addInfo !== null ? dataMutu.data.addInfo : '-',
                kotaTtd: dataPpm.tempatTtd !== null ? dataPpm.tempatTtd : '-',
            }
            // console.log(dataHcMutuUpd)
            const resSaveDraft = await transaksiService.addHcMutu(dataHcMutuUpd)
            if (resSaveDraft.data.kode === '200') {
                let ppmDetil = await transaksiService.listPpmDetilAll(dataPpm.nomorAju)
                ppmDetil.data.data.map(async (detil, index) => {
                    // console.log(detil)
                    let hcMutuDetilPK = {
                        nomorAju: detil.trPpkDtlPK.nomorAju,
                        noUrut: detil.trPpkDtlPK.seri
                    }
                    // console.log(hcMutuDetilPK)
                    let jsonHcMutuDetil = await transaksiService.getHcMutuDetailById(hcMutuDetilPK)

                    let dataHcMutuDetilUpt = {
                        ...jsonHcMutuDetil.data,
                        nmLatin: detil.namaLatin,
                        dtlNoReg: dataMutu.data.upiRegNo !== null ? dataMutu.data.upiRegNo : '-',
                        dtlNmUpi: dataMutu.upiNama,
                        dtlJmlKms: detil.jumlah !== null ? detil.jumlah : 0,
                        dtlJnsKms: detil.kodeSatuan !== null ? detil.kodeSatuan : '-',
                        dtlNetto: detil.netto !== null ? detil.netto : 0
                    }
                    await transaksiService.addHcMutuDetail(dataHcMutuDetilUpt)
                })
                setShowConfirmUpdCetakan(false)
                setShowUpdCetakanSuccess(true)
            } else {
                setShowConfirmUpdCetakan(false)
                setShowUpdCetakanFailed(true)
            }
            setLoadingUpdate(false)
        } catch (error) {
            setLoadingUpdate(false)
            setShowConfirmUpdCetakan(false)
            setShowUpdCetakanFailed(true)
        }
    }

    const handleClickUpdSuccess = () => {
        setShowUpdCetakanSuccess(false)
    }

    const handleClickUpdFailed = () => {
        setShowUpdCetakanFailed(false)
    }

    const [showConfirmSetuju, setShowConfirmSetuju] = useState(false)
    const handleCloseConfirmSetuju = () => setShowConfirmSetuju(false)
    const [showConfirmSetujuSuccess, setShowConfirmSetujuSuccess] = useState(false)
    const [showConfirmSetujuFailed, setShowConfirmSetujuFailed] = useState(false)

    const handleClickSetuju = (dataPenugasan) => {
        setShowConfirmSetuju(true)
        setDataDisposisi(dataPenugasan)

        let filename = 'SMKHP-' + datappm.nomorAju + '-' + getCurrentDateTimeFormattedOnly() + '.pdf'
        let urlFile = process.env.REACT_APP_API_URL_FILE + '/view/' + datappm.nomorAju + '/' + filename

        setFileName(filename)
        setQrText(urlFile)
        setUrlFile(urlFile)
    }

    const qrImageCanvas = useRef()
    const [qrText, setQrText] = useState('')

    const getQRCodeDataURL = (canvasRef) => {
        return new Promise((resolve) => {
            setTimeout(() => {
                const canvas = canvasRef.current?.children[0]; // Get the canvas inside <QRCode />
                if (canvas) {
                    resolve(canvas.toDataURL("image/png")); // Convert to Base64
                } else {
                    resolve(null);
                }
            }, 500); // Delay to ensure QR code renders
        });
    };

    const generateQrCode = async () => {
        const dataUrl = await getQRCodeDataURL(qrImageCanvas)
        // console.log(dataUrl)
        // setQrImage(dataUrl)
        return dataUrl
    }

    const handleClickConfirmSetuju = async () => {
        setLoadingSetuju(true)
        try {
            // let jsonPnbp = { idDisposisi: 10, nomorAju: datappm.nomorAju }
            let jsonSmkhp = { idDisposisi: 11, nomorAju: datappm.nomorAju }
            let resDisposisi = await transaksiService.addPenugasan(jsonSmkhp)
            if (resDisposisi.data.kode === '200') {
                // await transaksiService.addPenugasan(jsonSmkhp)

                let dataPpm = { ...datappm, status: '028' }
                await transaksiService.addPpm(dataPpm)

                let dataStatus = {
                    nomorAju: datappm.nomorAju,
                    kodeStatus: '028',
                    waktuStatus: new Date(),
                    createdBy: localStorage.getItem('username')
                }
                await transaksiService.addPpmStatus(JSON.stringify(dataStatus))

                const dataMutu = await transaksiService.getPpmMutuById(dataPpm.nomorAju)
                let jsonHcMutu = {
                    nomorAju: dataPpm.nomorAju,
                    noProses: dataDisposisi.noTugas
                }
                const dataHcMutu = await transaksiService.getHcMutuById(jsonHcMutu)
                if (dataHcMutu?.data !== null) {

                    let dataHcMutuUpd = {
                        ...dataHcMutu?.data,
                        nmPengirim: dataPpm.namaTrader,
                        alPengirim: dataPpm.alamatTrader,
                        kdposPengirim: dataPpm.kodeposTrader,
                        telpPengirim: '-',
                        nmPenerima: dataPpm.namaPartner,
                        alPenerima: dataPpm.alamatPartner,
                        kdposPenerima: '-',
                        telpPenerima: '-',
                        noRegUpi: dataMutu?.data?.upiRegNo,
                        nmUpi: dataMutu?.data?.upiNama,
                        alUpi: dataMutu?.data?.upiAlamat,
                        telpUpi: dataMutu?.data?.upiTelp,
                        deskripsiProduk: dataMutu?.data?.mutuDesk,
                        spesiesProduk: dataMutu?.data?.mutuJnsProduk,
                        negaraAsalProduk: dataMutu?.data?.mutuNegAsalProduk ?? '-',
                        wilayahAsalProduk: dataMutu?.data?.mutuNegAsalProduk ?? '-',
                        culturedArea: dataMutu?.data?.mutuArea,
                        catchArea: dataMutu?.data?.mutuTangkapArea,
                        kapalTangkap: dataMutu?.data?.mutuNamaKapal,
                        processingType: dataMutu?.data?.mutuProses,
                        temperatureUraian: dataMutu?.data?.mutuTemp,
                        ktgrTemperature: dataMutu?.data?.mutuTempTipe,
                        konsumsi: dataPpm.peruntukan,
                        netto: dataPpm.netto !== null ? dataPpm.netto : 0,
                        bruto: dataPpm.bruto !== null ? dataPpm.bruto : 0,
                        nmJnsTrans: dataPpm.angkut !== null ? dataPpm.angkut : '-',
                        jnsTrans: dataPpm.moda !== null ? dataPpm.moda : '-',
                        nmTrans: dataPpm.angkut !== null ? dataPpm.angkut : '-',
                        noFlight: dataPpm.voyage !== null ? dataPpm.voyage : '-',
                        nmTransLain: dataPpm.angkut !== null ? dataPpm.angkut : '-',
                        tglBerangkat: formatDateString(dataPpm.tanggalTibaBerangkat),
                        nmNgrTujuan: dataPpm.negaraPartner,
                        kdNgrTujuan: dataPpm.negaraPartner,
                        pelAsal: dataPpm.pelabuhanMuat,
                        pelTujuan: dataPpm.pelabuhanBongkar,
                        addInfo: dataMutu?.data?.addInfo ?? '-',
                        kotaTtd: dataPpm.tempatTtd !== null ? dataPpm.tempatTtd : '-',
                    }
                    // console.log(dataHcMutuUpd)
                    const qrImage = await generateQrCode()

                    const resKd = await masterService.getNegaraById(datappm.negaraPartner)
                    const respNoSeriE = await pbumkuService.ambilNomorService('FORM_' + resKd?.data?.kdHcm, datappm.kdUpt, currentYear, localStorage.getItem('username'))
                    let noHcMutuExt = respNoSeriE?.data.uraianPusat + respNoSeriE.data.nomorUrut
                    dataHcMutuUpd = {
                        ...dataHcMutu?.data,
                        noHcMutuExt: noHcMutuExt
                    }
                    await transaksiService.addHcMutu(dataHcMutuUpd)

                    try {
                        setTimeout(async () => {
                            let noTugas = dataDisposisi.noTugas
                            let finalFor = '1' // 1 = ki, 2 = fda
                            const pdfToBlob = await generatePdfToBlob({ datappm, noTugas, qrImage, finalFor })

                            const formData = new FormData()
                            formData.append('file', pdfToBlob, fileName)
                            const resUpload = await uploadService.uploadFileFormData(datappm.nomorAju, formData)
                            if (resUpload.status === 200) {
                                let jsonHcFile = {
                                    nomorAju: datappm.nomorAju,
                                    noHcMutu: dataHcMutuUpd.noHcMutu,
                                    noSeriMutuElectronic: noHcMutuExt,
                                    finalFor: '1',
                                    dokPath: urlFile,
                                    dokName: fileName,
                                    createdBy: localStorage.getItem("userId"),
                                    createdDate: new Date()
                                }
                                await transaksiService.saveSmkhpFile(jsonHcFile)
                            }

                        }, 100)
                    } catch (error) {
                        console.log(error)
                    }
                }

                setShowConfirmSetuju(false)
                setShowConfirmSetujuSuccess(true)
            } else {
                setShowConfirmSetuju(false)
                setShowConfirmSetujuFailed(true)
            }
        } catch (error) {
            console.log(error)
            setShowConfirmSetuju(false)
            setShowConfirmSetujuFailed(true)
        }
        setLoadingSetuju(false)
    }

    const handleClickVerSuccess = () => {
        setShowConfirmSetujuSuccess(false)
        // window.location.reload()
        reloadList(0, 10)
    }

    const handleClickVerFailed = () => {
        setShowConfirmSetujuFailed(false)
    }

    return (
        <>
            <div ref={qrImageCanvas} style={{ display: "none" }}>
                <QRCodeCanvas value={qrText} size={100} />
            </div>
            <div className="row">
                <div className="col-sm-4">
                    {
                        ((dataPenugasan.noTugas !== null && dataPenugasan.idDisposisi !== 9 && dataPenugasan.idDisposisi !== 10 && dataPenugasan.idDisposisi !== 11)) &&
                        <>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Lihat</Tooltip>
                            }>
                                <Button size="sm" variant="outline-info" onClick={() => handleShowView(dataPenugasan)}>
                                    <FaEye /> Lihat
                                </Button>
                            </OverlayTrigger>{' '}
                        </>
                    }
                    {(dataPenugasan.idDisposisi !== 1 && dataPenugasan.noTugas !== null) &&
                        <>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Cetak</Tooltip>
                            }>
                                <Button size="sm" variant="outline-warning" onClick={() => handleClickCetak(dataPenugasan)}>
                                    <FaPrint /> Cetak
                                </Button>
                            </OverlayTrigger>{' '}
                        </>
                    }
                    {(dataPenugasan.idDisposisi === 9 && datappm.status === '027') &&
                        <>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Klik Untuk Update Cetakan Draft SMKHP</Tooltip>
                            }>
                                <Button size="sm" variant="outline-danger" onClick={() => handleClickUpdCetakan(datappm, dataPenugasan)}>
                                    <FaPen /> Update Cetakan
                                </Button>
                            </OverlayTrigger>{' '}
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Persetujuan Cetakan Draft SMKHP</Tooltip>
                            }>
                                <Button size="sm" variant="outline-primary" onClick={() => handleClickSetuju(dataPenugasan)}>
                                    <FaPaperPlane /> Setuju
                                </Button>
                            </OverlayTrigger>{' '}
                        </>
                    }
                </div>
            </div>
            <ModalProses showAddProses={showAddProses} handleCloseAddProses={handleCloseAddProses} dataDisposisi={dataDisposisi} datappm={datappm} reloadList={reloadList} />
            <ModalSpp showAddPenugasan={showAddPenugasan} handleCloseAddPenugasan={handleCloseAddPenugasan} dataDisposisi={dataDisposisi} datappm={datappm} reloadList={reloadList} />
            <ModalLapEv showAddLapEv={showAddLapEv} handleCloseAddLapEv={handleCloseAddLapEv} dataDisposisi={dataDisposisi} datappm={datappm} reloadList={reloadList} />
            <ModalLapVerLap showAddLapVerLap={showAddLapVerLap} handleCloseAddLapVerLap={handleCloseAddLapVerLap} dataDisposisi={dataDisposisi} datappm={datappm} reloadList={reloadList} />
            <ModalCetak showCetak={showCetak} handleCloseCetak={handleCloseCetak} dataDisposisi={dataDisposisi} datappm={datappm} reloadList={reloadList} />
            <ModalPnbp showAddPnbp={showPnbp} handleClosePnbp={handleClosePnbp} dataDisposisi={dataDisposisi} datappm={datappm} reloadList={reloadList} />

            <ModalViewProses showViewProses={showViewProses} handleCloseViewProses={handleCloseViewProses} dataDisposisi={dataDisposisi} datappm={datappm} />
            <ModalViewSpp showViewPenugasan={showViewPenugasan} handleCloseViewPenugasan={handleCloseViewPenugasan} dataDisposisi={dataDisposisi} datappm={datappm} />
            <ModalViewLapEv showViewLapEv={showViewLapEv} handleCloseViewLapEv={handleCloseViewLapEv} dataDisposisi={dataDisposisi} datappm={datappm} />
            <ModalViewLapVerLap showViewLapVerLap={showViewLapVerLap} handleCloseViewLapVerLap={handleCloseViewLapVerLap} dataDisposisi={dataDisposisi} datappm={datappm} />

            {
                showConfirmUpdCetakan &&
                <SweetAlert
                    title="Update Cetakan SMKHP?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingUpdate ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Update...
                            </>
                        ) : (
                            "Update"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickSaveUpdCetakan}
                    onCancel={handleCloseConfirmUpdCetakan}
                    focusCancelBtn
                    reverseButtons={true}
                    btnSize="sm"
                    disabled={loadingUpdate}
                >
                    {loadingUpdate && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Update data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showUpdCetakanSuccess &&
                <SweetAlert
                    title="Cetakan SMKHP Berhasil Diupdate"
                    success
                    onConfirm={handleClickUpdSuccess}
                    btnSize="sm"
                />
            }
            {
                showUpdCetakanFailed &&
                <SweetAlert
                    title="Cetakan SMKHP Gagal Diupdate"
                    danger
                    onConfirm={handleClickUpdFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }

            {
                showConfirmSetuju &&
                <SweetAlert
                    title="Setuju Cetakan SMKHP?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSetuju ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Update...
                            </>
                        ) : (
                            "Proses"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickConfirmSetuju}
                    onCancel={handleCloseConfirmSetuju}
                    focusCancelBtn
                    reverseButtons={true}
                    btnSize="sm"
                    disabled={loadingSetuju}
                >
                    {loadingSetuju && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Update data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showConfirmSetujuSuccess &&
                <SweetAlert
                    title="Cetakan SMKHP Berhasil Disetujui"
                    success
                    onConfirm={handleClickVerSuccess}
                    btnSize="sm"
                />
            }
            {
                showConfirmSetujuFailed &&
                <SweetAlert
                    title="Cetakan SMKHP Gagal Disetujui"
                    danger
                    onConfirm={handleClickVerFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

const GetNomorSertifikat = ({ nomoraju, noTugas }) => {
    let transaksiService = useMemo(() => new TransaksiService(), [])
    const [dataHc, setDataHc] = useState(null)

    useEffect(() => {
        const getHcMutu = async () => {
            try {
                let jsonMutuPK = {
                    nomorAju: nomoraju,
                    noProses: noTugas
                }
                const resHc = await transaksiService.getHcMutuById(jsonMutuPK)
                setDataHc(resHc.data)
            } catch (error) {
                setDataHc(null)
            }
        }
        getHcMutu()
    }, [transaksiService, nomoraju, noTugas])

    return (
        <>
            {
                dataHc !== null ? dataHc.noHcMutu : ''
            } /{' '}
            {
                dataHc !== null ? dataHc.noHcMutuExt : ''
            }
        </>
    )
}

export default ExpandableComponent